import StarShape from "./StarShape";

import DeleteButton from "./TaskCard/DeleteButton";
import SwitchAdd from "./TaskCard/SwitchAdd";
import { getCardVariant } from "./TaskCard/TaskCard";
import CardAttemptsBadge from "./TaskCard/CardAttemptsBadge";
import { NodeTaskData } from "../../nodes/mapper";
import { SwitchTaskDef } from "../../../../types/TaskType";

interface DecisionOperatorProps {
  nodeData: NodeTaskData<SwitchTaskDef>;
  nodeWidth: number;
  portsVisible: boolean;
  isInconsistent: boolean;
}

const DecisionOperator = ({
  nodeData,
  nodeWidth,
  portsVisible,
  isInconsistent,
}: DecisionOperatorProps) => {
  const {
    task: { name, taskReferenceName },
  } = nodeData;

  const decisionOperatorStyles = {
    width: `${nodeWidth - 100}px`,
    height: `${portsVisible ? 190 : 200}px`,
    cursor: isInconsistent ? "not-allowed" : "pointer",
    boxShadow: "none",
    border: "1px dashed black",
    ...getCardVariant(nodeData.task.type, nodeData.status!, nodeData.selected),
    backgroundColor: "rgba(128, 128, 128, .5)",
    borderRadius: "20px",
  };

  return (
    <div
      style={{
        paddingBottom: "10px",
      }}
    >
      <div style={{ ...decisionOperatorStyles }}>
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          {/* Definition */}
          {/* <DeleteButton maybeHideData={nodeData} /> */}
          {(nodeData?.attempts ?? 0) > 1 ? (
            <CardAttemptsBadge attempts={nodeData.attempts} />
          ) : null}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 1,
            }}
          >
            <StarShape />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 2,
            }}
          >
            <div style={{ color: "black" }}>{name}</div>
            <div style={{ color: "#aaa" }}>{taskReferenceName}</div>
          </div>
          {/* <SwitchAdd nodeData={nodeData} /> */}
        </div>
      </div>
    </div>
  );
};

export default DecisionOperator;
